<template>
  <div :class="['status', type]" :style="noBorder ? style : ''">
    <div class="circle" v-if="type !== 'pending' && type !== 'confirming'&&type !== 'reviewing'">
      <div></div>
    </div>
    <div class="icon" v-else>
      <svg-icon name="lishijilu" style="color: #E68200;font-size: 16px;"/>
    </div>
    <div class="textStyle">{{ text }}</div>
  </div>
</template>
<script setup>
import SvgIcon from '~/components/SvgIcon.vue';

defineProps(['type', 'noBorder', 'text'])
const style = {
  border: 'unset',
  background: 'transparent',
  'box-shadow': 'unset'
}
</script>
<style lang="less" scoped>
@flex: {
  display: flex;
  align-items: center;
  justify-content: center;
}

@font: {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  border-radius: 4px;
  letter-spacing: 0.4px;
}

// 默认inactive
.status {
  @font();
  display: inline-flex;
  padding: 0 6px;
  color: #878394;
  align-items: center;
  background: #EBE9F0;
  border: 1px solid var(--border-1);
  box-shadow: 0 1px 0 0 var(--box-shadow-1);
  white-space: nowrap;
  .icon{
    margin-right: 3px;
    width: 18px;
    height: 18px;
  }
  .circle {
    @flex();
    width: 12px;
    height: 12px;
    margin-right: 3px;
    border-radius: 50%;
    background: #DFDCE5;

    >div {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #ABA8B4;
    }
  }
}
.pending,
.Pending,
.confirming,
.reviewing
{
  color: #E68200;
  background: #FFF7EB;
  border: 1px solid rgba(244, 202, 132, 1);
  box-shadow: 0 1px 0 0 #1a16250d;
  
}
.declined,.cancelled,.suspended,.Rejected,.rejected,.insufficient_stock,.offline{
  color: #EB4E3D;
  background: rgba(253, 238, 236, 1);
  border: 1px solid rgba(255, 195, 195, 1);
  box-shadow: 0 1px 0 0 #1a16250d;

  .circle {
    background: rgba(242, 85, 68, 0.2);

    >div {
      background-color: rgba(242, 85, 68, 1);
    }
  }
}
// .accepted{
//   color: #009947;
//   background: #F0FDF6;
//   border: 1px solid rgba(151, 211, 179, 1);
//   box-shadow: 0 1px 0 0 #1a16250d;

//   .circle {
//     background: #C2E7D4;

//     >div {
//       background-color: #2AAE67;
//     }
//   }
// }
.active,
.completed,
.accepted,
.confirmed,
.Approved,
.approved,
.completed
 {
  color: #009947;
  background: #F0FDF6;
  border: 1px solid rgba(151, 211, 179, 1);
  box-shadow: 0 1px 0 0 #1a16250d;

  .circle {
    background: #C2E7D4;

    >div {
      background-color: #2AAE67;
    }
  }
}
.inactive {
  color: #0f0629;
  
  // background: #f59b001a;
  border: 1px solid  #FFF;;
  background: #FFF;
  box-shadow: 0 1px 0 0 #1a16250d;
  .textStyle{
    opacity: 0.3;
  }
  .circle {
    background: rgba(171, 168, 180, 0.2);

    >div {
      background-color: #ABA8B4;
    }
  }
}
 .published,
 .accepted,
 .paid {
  color: #7653DA;
  background: rgba(138, 100, 244, 0.1);
  border: 1px solid rgba(138, 100, 244, 0.1);
  box-shadow: 0 1px 0 0 #1a16250d;

  .circle {
    background: rgba(138, 100, 244, 0.2);

    >div {
      background-color: rgba(138, 100, 244, 1);
    }
  }
}

</style>